export default __webpack_public_path__ + "static/media/paperplane_islamic.ec4d53b0.gif";